import { render, staticRenderFns } from "./WillBeInTouch.vue?vue&type=template&id=3ba7f74f&"
import script from "./WillBeInTouch.vue?vue&type=script&lang=js&"
export * from "./WillBeInTouch.vue?vue&type=script&lang=js&"
import style0 from "./WillBeInTouch.vue?vue&type=style&index=0&id=3ba7f74f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports